import { CONFIG } from '../config.js';

let S = CONFIG.speed;

/** Dificultad: 'normal' o 'soft' (más lenta, para jugar con la cámara). Afecta a la siguiente partida. */
export function setDifficulty(level) {
  S = level === 'soft' ? CONFIG.softSpeed : CONFIG.speed;
}

/** Velocidad de carrera en función de los metros recorridos. */
export function speedAt(distance) {
  return Math.min(S.max, S.base + distance * S.perMeter);
}
